import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Menu, MenuItem, Link } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../constants';
import PropTypes from 'prop-types';
import { CONSTANTS } from '../../../../constants/constants';

const MobileMenuItem = ({ document, setCancelFlowDialog, setDeleteFlowDialog }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const { status, flowId } = document;
  const ITEM_HEIGHT = 48;
  const PATH_VIEW_DOCUMENT = `${config.FIRMA_FRONT_URL}/validate/${flowId}`;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton aria-label='more' aria-controls='long-menu' aria-haspopup='true' onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '30ch'
          }
        }}
      >
        {status === CONSTANTS.DOCUMENT.STATUS.INIT &&
          <Link component={RouterLink} to={`/file/flow/${document.id}`} style={{ textDecoration: 'none' }}>
            <MenuItem>
              {t('documentMenu:createFlow')}
            </MenuItem>
          </Link>}
        {(status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN || status === CONSTANTS.DOCUMENT.STATUS.SIGNED) &&
          <Link
            component={RouterLink}
            to={{ pathname: PATH_VIEW_DOCUMENT }}
            style={{ textDecoration: 'none' }}
            target='_blank'
          >
            <MenuItem>
              {t('fileMenu:viewTransaction')}
            </MenuItem>
          </Link>
        }
        {(status === CONSTANTS.DOCUMENT.STATUS.REJECTED || status === CONSTANTS.DOCUMENT.STATUS.CANCELLED || status === CONSTANTS.DOCUMENT.STATUS.INIT) &&
          <MenuItem key='Eliminar' onClick={() => setDeleteFlowDialog(true)}>
            {t('documentMenu:delete')}
          </MenuItem>}
        {status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN &&
          <MenuItem
            key='Cancelar' onClick={() => {
              setCancelFlowDialog(true);
              handleClose();
            }}
          >
            {t('documentMenu:cancel')}
          </MenuItem>}
      </Menu>
    </>
  );
};

MobileMenuItem.propTypes = {
  document: PropTypes.object,
  setCancelFlowDialog: PropTypes.func,
  setDeleteFlowDialog: PropTypes.func
};

export default MobileMenuItem;
